var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"toProject",on:{"click":_vm.toProject}}),_c('img',{staticClass:"full-image",attrs:{"src":require("../asset/img/1.jpg"),"alt":"首页"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }